import {HexColor, HsvColor} from './colorTypes';
import {hsvToRgb} from './hsvToRgb';
import {rgbToHex} from './rgbToHex';

/**
 * @name hsvToHex
 * @description Converts an HSV object into a hex code
 */
export const hsvToHex = (hsv: HsvColor): HexColor => {
  const rgb = hsvToRgb(hsv);
  return rgbToHex(rgb);
};
